import * as React from 'react'
import { Button } from 'antd'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { IBaseProduct } from '@getgreenline/homi-shared'
import { InventoryLogsTable } from '../../../../../../components/InventoryLogs/InventoryLogsTable'
import { InventoryLogsSearchFilters } from '../../../../../../components/InventoryLogs/InventoryLogsSearchFilters'
import { InventoryLogStore } from './InventoryLogStore'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  locationId: number
  product: IBaseProduct
  inventoryLogStore: InventoryLogStore
}

@inject('currentCompanyStore')
@observer
export class EventLogs extends React.Component<Props, {}> {
  componentDidMount() {
    this.props.currentCompanyStore!.getEntityUsers()
    const { getInventoryLogs } = this.props.inventoryLogStore
    getInventoryLogs()
  }

  handleLogsPerPageChange = (perPage: number) => {
    const { inventoryLogFilter, getInventoryLogs } = this.props.inventoryLogStore
    inventoryLogFilter.limit = perPage
    inventoryLogFilter.offset = 0
    getInventoryLogs()
  }

  render() {
    const { logs, isLastPage, isLoading, inventoryLogFilter, getInventoryLogs } =
      this.props.inventoryLogStore

    return (
      <div>
        <InventoryLogsSearchFilters
          currentCompanyStore={this.props.currentCompanyStore!}
          inventoryLogFilter={inventoryLogFilter}
          hideFilters={['product', 'perPage', 'category']}
          onLogsPerPageChange={this.handleLogsPerPageChange}
          isLoading={isLoading}
        />
        <InventoryLogsTable
          companyId={this.props.currentCompanyStore!.company!.id}
          onChange={getInventoryLogs}
          logs={logs}
          isLoading={isLoading}
        />
        <br />
        {!isLastPage && (
          <div>
            <Button
              onClick={() => {
                inventoryLogFilter.limit = inventoryLogFilter.limit
                  ? inventoryLogFilter.limit + 50
                  : 50
                getInventoryLogs()
              }}
            >
              <span className='mr-2'>Load more</span>
            </Button>
          </div>
        )}
      </div>
    )
  }
}
